import { render, staticRenderFns } from "./MyOrderList.vue?vue&type=template&id=022046fd&scoped=true&"
import script from "./MyOrderList.vue?vue&type=script&lang=js&"
export * from "./MyOrderList.vue?vue&type=script&lang=js&"
import style0 from "./MyOrderList.vue?vue&type=style&index=0&id=022046fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022046fd",
  null
  
)

export default component.exports